"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheKeys = _interopRequireDefault(require("reference-resolvers/constants/CacheKeys"));

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("reference-resolvers/lib/createSimpleCachedReferenceResolver"));

var _TeamsAPI = require("reference-resolvers/api/TeamsAPI");

var _default = (0, _createSimpleCachedReferenceResolver.default)({
  cacheKey: _CacheKeys.default.TEAMS,
  fetchData: _TeamsAPI.getAllTeams
});

exports.default = _default;
module.exports = exports.default;